module.exports = __webpack_public_path__ + "img/nav-design-withdiamonds@2x.cbeed10.jpg";